export const getUniqueId = (() => {
  let i = 0;
  return () => {
    i += 1;
    return `canary-id-${i}`;
  };
})();
